import { component } from "picoapp";
import { merge } from "lodash";
const Flickity = require("flickity");
const str2json = require("../../utils/str2json");
import getClosest from "../../utils/getClosest";
import jQuery from "jquery";
// import jump from 'jump.js';
// const delegate = require('delegate');

class Slider {
  constructor(el) {
    if (!el) {
      return;
    }
    this._init(el);
    this.bindEvents();
  }

  _init(el) {
    this.el = el;

    this.defaults = {
      autoPlay: false,
      contain: true,
      customUI: false,
      draggable: true,
      cellSelector: ".Slider__item",
      cellAlign: "left",
      prevNextButtons: true,
      pageDots: true,
      groupCells: false,
      wrapAround: true,
      arrowShape:
        "M72.8536585,8.13157895 C71.420864,6.6334674 69.0318491,6.6334674 67.1219512,8.13157895 L28.1463415,47.7368421 C26.631552,48.8114676 26.631552,51.1880631 28.1463415,52.2631579 L67.1219512,91.8684211 C68.2940096,92.6339367 69.258296,93 70.5609756,93 C71.190643,93 72.1568165,92.6339367 72.8536585,91.8684211 C74.368448,90.4338025 74.368448,88.0572069 72.8536585,86.2105263 L36.1707317,50 L72.8536585,13.7894737 C74.3665609,11.9423237 74.3665609,9.56572822 72.8536585,8.13157895 L72.8536585,8.13157895 Z",
    };

    this.options = merge(this.defaults, str2json(el.dataset.options));

    this.parentControllerEl = getClosest(this.el, ".js-sliderController");
    el.classList.remove("is-hidden");
    // trigger redraw for transition
    el.offsetHeight;

    this.sliderEl = new Flickity(el, this.options);

    if (this.options.customUI) {
      this.initCustomUI(this.sliderEl);
    }

    if (this.options.sameHeight) {
      this.resizeCells()
    }
  }

  initCustomUI(slider) {
    const containerEl = this.options.referenceElement
      ? getClosest(this.el, this.options.referenceElement)
      : this.el.parentNode;
    console.log(containerEl)
    // previous
    var previousButton = containerEl.querySelector(".button--previous");
    if (previousButton) {
      previousButton.addEventListener("click", () => {
        this.sliderEl.previous();
      });
    }

    // next
    var nextButton = containerEl.querySelector(".button--next");
    // console.log('CONTAINER: ', containerEl);
    if (nextButton) {
      // console.log('NEXT BUTTON: ', nextButton);
      nextButton.addEventListener("click", () => {
        this.sliderEl.next();
      });
    }
  }

  resizeCells() {
    this.sliderEl.cells.forEach((el) => {
      el.element.style.height = null;
      this.sliderEl.resize();
      setTimeout(() => {
        el.element.style.height = '100%';
        this.sliderEl.resize();
      }, 500);
    })
  }

  bindEvents() {
    window.addEventListener("load", () => {
      this.sliderEl.resize();
    });

    window.addEventListener('resize', () => {
      if (this.options.sameHeight) {
        this.resizeCells()
      }
    })

    if (this.parentControllerEl) {
      this.parentControllerEl.addEventListener('isActive', (e) => {
        this.sliderEl.resize();
      });
    }

    this.sliderEl.on("staticClick", function (
      event,
      pointer,
      cellElement,
      cellIndex
    ) {
      if (!cellElement) {
        return;
      }
      event.target.click();
    });
  }
}

// module.exports = Slider;
export default component((node, ctx) => {
  new Slider(node, ctx);
});
